module.exports = __webpack_public_path__ + "static/media/london-26.6b63b7bb.jpg";